/* istanbul ignore file */

// import icons from @lely/icons
import IconDiscovery from '@lely/icons/src/assets/collector.svg?react';
import ChevronDownIcon from '@lely/icons/src/assets/chevron-down.svg?react';

// Import statements for icons from resources folder
import Icon3gMobiledata from './3g-mobiledata.svg?react';
import Icon4gMobiledata from './4g-mobiledata.svg?react';
import Icon5gMobiledata from './5g-mobiledata.svg?react';
import IconAbortion from './abortion.svg?react';
import IconAccountBalance from './account-balance.svg?react';
import IconAccount from './account.svg?react';
import IconActivities from './activities.svg?react';
import IconAddFile from './add-file.svg?react';
import IconAlarm from './alarm.svg?react';
import IconApps from './apps.svg?react';
import IconArchive from './archive.svg?react';
import IconArrowDown from './arrow-down.svg?react';
import IconArrowLeft from './arrow-left.svg?react';
import IconArrowRight from './arrow-right.svg?react';
import IconArrowUp from './arrow-up.svg?react';
import IconAstronaut from './astronaut.svg?react';
import IconBackup from './backup.svg?react';
import IconBarChart from './bar-chart.svg?react';
import IconBarGraph from './bar-graph.svg?react';
import IconBarn from './barn.svg?react';
import IconBattery1Bar from './battery-1-bar.svg?react';
import IconBattery2Bar from './battery-2-bar.svg?react';
import IconBatteryCharging from './battery-charging.svg?react';
import IconBatteryFull from './battery-full.svg?react';
import IconBlock from './block.svg?react';
import IconBluetoothConnected from './bluetooth-connected.svg?react';
import IconBluetoothDisabled from './bluetooth-disabled.svg?react';
import IconBluetoothSearching from './bluetooth-searching.svg?react';
import IconBluetooth from './bluetooth.svg?react';
import IconBugReport from './bug-report.svg?react';
import IconCalendar from './calendar.svg?react';
import IconCall from './call.svg?react';
import IconCardView from './card-view.svg?react';
import IconCaretDown from './caret-down.svg?react';
import IconCaretLeft from './caret-left.svg?react';
import IconCaretRight from './caret-right.svg?react';
import IconCaretUp from './caret-up.svg?react';
import IconCash from './cash.svg?react';
import IconCategory from './category.svg?react';
import IconCentralUnit from './central-unit.svg?react';
import IconChargingStation from './charging-station.svg?react';
import IconChart from './chart.svg?react';
import IconChatBubble from './chat-bubble.svg?react';
import IconCheck from './check.svg?react';
import IconChecklist from './checklist.svg?react';
import IconChevronLeft from './chevron-left.svg?react';
import IconChevronRight from './chevron-right.svg?react';
import IconCircleCheck from './circle-check.svg?react';
import IconClockInterval from './clock-interval.svg?react';
import IconClock from './clock.svg?react';
import IconClose from './close.svg?react';
import IconCloudBackup from './cloud-backup.svg?react';
import IconCloudDone from './cloud-done.svg?react';
import IconCloudDownload from './cloud-download.svg?react';
import IconCloud from './cloud.svg?react';
import IconComment from './comment.svg?react';
import IconComputer from './computer.svg?react';
import IconCopy from './copy.svg?react';
import IconCow from './cow.svg?react';
import IconCreditcard from './creditcard.svg?react';
import IconDataPoints from './data-points.svg?react';
import IconDashboard from './dashboard.svg?react';
import IconDigram from './digram.svg?react';
import IconDisease from './disease.svg?react';
import IconDissatisfied from './dissatisfied.svg?react';
import IconDocument from './document.svg?react';
import IconDownloadDone from './download-done.svg?react';
import IconDownload from './download.svg?react';
import IconDrag from './drag.svg?react';
import IconDriver from './driver.svg?react';
import IconDryOff from './dry-off.svg?react';
import IconEast from './east.svg?react';
import IconEdit from './edit.svg?react';
import IconEmergency from './emergency.svg?react';
import IconEmotions from './emotions.svg?react';
import IconEngine from './engine.svg?react';
import IconError from './error.svg?react';
import IconExport from './export.svg?react';
import IconFarm from './farm.svg?react';
import IconFeed from './feed.svg?react';
import IconFence from './fence.svg?react';
import IconFetchCow from './fetch-cow.svg?react';
import IconFilter from './filter.svg?react';
import IconFingerprint from './fingerprint.svg?react';
import IconFolderOpen from './folder-open.svg?react';
import IconFolderZip from './folder-zip.svg?react';
import IconFullscreenExit from './fullscreen-exit.svg?react';
import IconFullscreen from './fullscreen.svg?react';
import IconGrabber from './grabber.svg?react';
import IconGraphDown from './graph-down.svg?react';
import IconGraphUp from './graph-up.svg?react';
import IconGraphView from './graph-view.svg?react';
import IconGraph from './graph.svg?react';
import IconGrass from './grass.svg?react';
import IconGridView from './grid-view.svg?react';
import IconGrid from './grid.svg?react';
import IconGroupAdd from './group-add.svg?react';
import IconGroupRemove from './group-remove.svg?react';
import IconGroup from './group.svg?react';
import IconHealthReport from './health-report.svg?react';
import IconHealthTreatment from './health-treatment.svg?react';
import IconHeat from './heat.svg?react';
import IconHelp from './help.svg?react';
import IconHerdMovement from './herd-movement.svg?react';
import IconHerd from './herd.svg?react';
import IconHide from './hide.svg?react';
import IconHistory from './history.svg?react';
import IconHome from './home.svg?react';
import IconHotRins from './hot-rins.svg?react';
import IconHuman from './human.svg?react';
import IconIncome from './income.svg?react';
import IconInformation from './information.svg?react';
import IconInsemination from './insemination.svg?react';
import IconIrisGroup from './iris-group.svg?react';
import IconIris from './iris.svg?react';
import IconKeyboard from './keyboard.svg?react';
import IconLanguage from './language.svg?react';
import IconLaptop from './laptop.svg?react';
import IconLayersClear from './layers-clear.svg?react';
import IconLayers from './layers.svg?react';
import IconLink from './link.svg?react';
import IconLinkOff from './link-off.svg?react';
import IconListBulletin from './list-bulletin.svg?react';
import IconList from './list.svg?react';
import IconLocate from './locate.svg?react';
import IconLocation from './location.svg?react';
import IconLock from './lock.svg?react';
import IconLogin from './login.svg?react';
import IconLogout from './logout.svg?react';
import IconM4use from './m4use.svg?react';
import IconMail from './mail.svg?react';
import IconManage from './manage.svg?react';
import IconManure from './manure.svg?react';
import IconMap from './map.svg?react';
import IconMapSearch from './map-search.svg?react';
import IconMedicine from './medicine.svg?react';
import IconMenu from './menu.svg?react';
import IconMfrDosingRoller from './mfr-dosing-roller.svg?react';
import IconMfrFeedDoorClosing from './mfr-feed-door-closing.svg?react';
import IconMfrFeedDoorOpening from './mfr-feed-door-opening.svg?react';
import IconMfrOpen from './mfr-open.svg?react';
import IconMfr from './mfr.svg?react';
import IconBc from './bc.svg?react';
import IconMicrophone from './microphone.svg?react';
import IconMilkSeperation from './milk-seperation.svg?react';
import IconMilk from './milk.svg?react';
import IconMinus from './minus.svg?react';
import IconMixerMotor from './mixer-motor.svg?react';
import IconMoreHorizontal from './more-horizontal.svg?react';
import IconMoreVertical from './more-vertical.svg?react';
import IconMouse from './mouse.svg?react';
import IconNetworkWifi from './network-wifi.svg?react';
import IconNeutral from './neutral.svg?react';
import IconNorthEast from './north-east.svg?react';
import IconNorthWest from './north-west.svg?react';
import IconNorth from './north.svg?react';
import IconNotificationMute from './notification-mute.svg?react';
import IconNotificationOn from './notification-on.svg?react';
import IconNotification from './notification.svg?react';
import IconNotifications from './notifications.svg?react';
import IconObjects from './objects.svg?react';
import IconOngoing from './ongoing.svg?react';
import IconOpportunities from './opportunities.svg?react';
import IconPains from './pains.svg?react';
import IconPan from './pan.svg?react';
import IconPanel from './panel.svg?react';
import IconPause from './pause.svg?react';
import IconPdb from './pdb.svg?react';
import IconPending from './pending.svg?react';
import IconPersonApprove from './person-approve.svg?react';
import IconPersonAssign from './person-assign.svg?react';
import IconPersonRemove from './person-remove.svg?react';
import IconPersonUnassign from './person-unassign.svg?react';
import IconPerson from './person.svg?react';
import IconPhone from './phone.svg?react';
import IconPicture from './picture.svg?react';
import IconPincZoomOut from './pinc-zoom-out.svg?react';
import IconPinchZoomIn from './pinch-zoom-in.svg?react';
import IconPlay from './play.svg?react';
import IconPlus from './plus.svg?react';
import IconPowerManagement from './power-management.svg?react';
import IconPower from './power.svg?react';
import IconPregnancy from './pregnancy.svg?react';
import IconPrinter from './printer.svg?react';
import IconQrCodeScanner from './qr-code-scanner.svg?react';
import IconQrCode from './qr-code.svg?react';
import IconRedo from './redo.svg?react';
import IconRefresh from './refresh.svg?react';
import IconReminder from './reminder.svg?react';
import IconReports from './reports.svg?react';
import IconReproductionCheck from './reproduction-check.svg?react';
import IconReset from './reset.svg?react';
import IconRobot from './robot.svg?react';
import IconRotateLeft from './rotate-left.svg?react';
import IconRotateMap from './rotate-map.svg?react';
import IconRotateRight from './rotate-right.svg?react';
import IconRouteLayers from './route-layers.svg?react';
import IconRoutes from './routes.svg?react';
import IconRouting from './routing.svg?react';
import IconSatisfied from './satisfied.svg?react';
import IconScanner from './scanner.svg?react';
import IconScatterplot from './scatterplot.svg?react';
import IconScale from './scale.svg?react';
import IconScreenRotation from './screen-rotation.svg?react';
import IconSearch from './search.svg?react';
import IconSend from './send.svg?react';
import IconSensor from './sensor.svg?react';
import IconSettings from './settings.svg?react';
import IconShoppingCart from './shopping-cart.svg?react';
import IconShow from './show.svg?react';
import IconSignalCellular0Bar from './signal-cellular-0-bar.svg?react';
import IconSignalCellular2Bar from './signal-cellular-2-bar.svg?react';
import IconSignalCellular4Bar from './signal-cellular-4-bar.svg?react';
import IconSignalCellularOff from './signal-cellular-off.svg?react';
import IconSignalWifiBad from './signal-wifi-bad.svg?react';
import IconSignalWifiOff from './signal-wifi-off.svg?react';
import IconSires from './sires.svg?react';
import IconSortDisabled from './sort-disabled.svg?react';
import IconSortDown from './sort-down.svg?react';
import IconSortUp from './sort-up.svg?react';
import IconSort from './sort.svg?react';
import IconSouthEast from './south-east.svg?react';
import IconSouthWest from './south-west.svg?react';
import IconSouth from './south.svg?react';
import IconStackedBarChart from './stacked-bar-chart.svg?react';
import IconStarEmpty from './star-empty.svg?react';
import IconStarFilled from './star-filled.svg?react';
import IconStop from './stop.svg?react';
import IconSwipeDown from './swipe-down.svg?react';
import IconSwipeLeftAndRight from './swipe-left-and-right.svg?react';
import IconSwipeLeft from './swipe-left.svg?react';
import IconSwipeUp from './swipe-up.svg?react';
import IconTableRow from './table-row.svg?react';
import IconTable from './table.svg?react';
import IconTablet from './tablet.svg?react';
import IconTasks from './tasks.svg?react';
import IconThermostat from './thermostat.svg?react';
import IconThumbDown from './thumb-down.svg?react';
import IconThumbUp from './thumb-up.svg?react';
import IconTouch from './touch.svg?react';
import IconTraffic from './traffic.svg?react';
import IconTransfer from './transfer.svg?react';
import IconTrash from './trash.svg?react';
import IconTv from './tv.svg?react';
import IconUndo from './undo.svg?react';
import IconUpdate from './update.svg?react';
import IconUpload from './upload.svg?react';
import IconValve from './valve.svg?react';
import IconVersion from './version.svg?react';
import IconVeryDissatisfied from './very-dissatisfied.svg?react';
import IconVerySatisfied from './very-satisfied.svg?react';
import IconViewList from './view-list.svg?react';
import IconWarning from './warning.svg?react';
import IconWatch from './watch.svg?react';
import IconWater from './water.svg?react';
import IconWest from './west.svg?react';
import IconWifiOff from './wifi-off.svg?react';
import IconWifi from './wifi.svg?react';
import IconYoungStock from './young-stock.svg?react';
import IconZoomIn from './zoom-in.svg?react';
import IconZoomOut from './zoom-out.svg?react';
import IconGraphBottom from './graph-bottom.svg?react';
import IconGraphTop from './graph-top.svg?react';
import IconHub from './hub.svg?react';
import IconSphere from './sphere.svg?react';
import IconRadioChecked from '../RadioChecked.svg?react';
import IconRadioDefault from '../RadioDefault.svg?react';
import IconAmfRobot from './amf.svg?react';
import IconJuno from './juno.svg?react';
import IconWarningLarge from '../Warning.svg?react';
import IconNotFound from '../404 error.svg?react';
import IconNoRobots from '../No robot found.svg?react';
import ExpandPanel from './expand-panel.svg?react';
import CollapsePanel from './collapse-panel.svg?react';

const iconComponents = {
  'lely-icon-discovery': IconDiscovery,
  'lely-icon-3g-mobiledata': Icon3gMobiledata,
  'lely-icon-4g-mobiledata': Icon4gMobiledata,
  'lely-icon-5g-mobiledata': Icon5gMobiledata,
  'lely-icon-abortion': IconAbortion,
  'lely-icon-account-balance': IconAccountBalance,
  'lely-icon-account': IconAccount,
  'lely-icon-activities': IconActivities,
  'lely-icon-add-file': IconAddFile,
  'lely-icon-alarm': IconAlarm,
  'lely-icon-apps': IconApps,
  'lely-icon-archive': IconArchive,
  'lely-icon-arrow-down': IconArrowDown,
  'lely-icon-arrow-left': IconArrowLeft,
  'lely-icon-arrow-right': IconArrowRight,
  'lely-icon-arrow-up': IconArrowUp,
  'lely-icon-astronaut': IconAstronaut,
  'lely-icon-backup': IconBackup,
  'lely-icon-bar-chart': IconBarChart,
  'lely-icon-bar-graph': IconBarGraph,
  'lely-icon-barn': IconBarn,
  'lely-icon-battery-1-bar': IconBattery1Bar,
  'lely-icon-battery-2-bar': IconBattery2Bar,
  'lely-icon-battery-charging': IconBatteryCharging,
  'lely-icon-battery-full': IconBatteryFull,
  'lely-icon-bc': IconBc,
  'lely-icon-block': IconBlock,
  'lely-icon-bluetooth-connected': IconBluetoothConnected,
  'lely-icon-bluetooth-disabled': IconBluetoothDisabled,
  'lely-icon-bluetooth-searching': IconBluetoothSearching,
  'lely-icon-bluetooth': IconBluetooth,
  'lely-icon-bug-report': IconBugReport,
  'lely-icon-calendar': IconCalendar,
  'lely-icon-call': IconCall,
  'lely-icon-card-view': IconCardView,
  'lely-icon-caret-down': IconCaretDown,
  'lely-icon-caret-left': IconCaretLeft,
  'lely-icon-caret-right': IconCaretRight,
  'lely-icon-caret-up': IconCaretUp,
  'lely-icon-cash': IconCash,
  'lely-icon-category': IconCategory,
  'lely-icon-central-unit': IconCentralUnit,
  'lely-icon-charging-station': IconChargingStation,
  'lely-icon-chart': IconChart,
  'lely-icon-chat-bubble': IconChatBubble,
  'lely-icon-check': IconCheck,
  'lely-icon-checklist': IconChecklist,
  'lely-icon-chevron-left': IconChevronLeft,
  'lely-icon-chevron-right': IconChevronRight,
  'lely-icon-chevron-down': ChevronDownIcon,
  'lely-icon-circle-check': IconCircleCheck,
  'lely-icon-clock-interval': IconClockInterval,
  'lely-icon-clock': IconClock,
  'lely-icon-close': IconClose,
  'lely-icon-cloud-backup': IconCloudBackup,
  'lely-icon-cloud-done': IconCloudDone,
  'lely-icon-cloud-download': IconCloudDownload,
  'lely-icon-cloud': IconCloud,
  'lely-icon-comment': IconComment,
  'lely-icon-computer': IconComputer,
  'lely-icon-copy': IconCopy,
  'lely-icon-cow': IconCow,
  'lely-icon-creditcard': IconCreditcard,
  'lely-icon-data-points': IconDataPoints,
  'lely-icon-dashboard': IconDashboard,
  'lely-icon-digram': IconDigram,
  'lely-icon-disease': IconDisease,
  'lely-icon-dissatisfied': IconDissatisfied,
  'lely-icon-document': IconDocument,
  'lely-icon-download-done': IconDownloadDone,
  'lely-icon-download': IconDownload,
  'lely-icon-drag': IconDrag,
  'lely-icon-driver': IconDriver,
  'lely-icon-dry-off': IconDryOff,
  'lely-icon-east': IconEast,
  'lely-icon-edit': IconEdit,
  'lely-icon-emergency': IconEmergency,
  'lely-icon-emotions': IconEmotions,
  'lely-icon-engine': IconEngine,
  'lely-icon-error': IconError,
  'lely-icon-export': IconExport,
  'lely-icon-farm': IconFarm,
  'lely-icon-feed': IconFeed,
  'lely-icon-fence': IconFence,
  'lely-icon-fetch-cow': IconFetchCow,
  'lely-icon-filter': IconFilter,
  'lely-icon-fingerprint': IconFingerprint,
  'lely-icon-folder-open': IconFolderOpen,
  'lely-icon-folder-zip': IconFolderZip,
  'lely-icon-fullscreen-exit': IconFullscreenExit,
  'lely-icon-fullscreen': IconFullscreen,
  'lely-icon-grabber': IconGrabber,
  'lely-icon-graph-down': IconGraphDown,
  'lely-icon-graph-up': IconGraphUp,
  'lely-icon-graph-view': IconGraphView,
  'lely-icon-graph': IconGraph,
  'lely-icon-grass': IconGrass,
  'lely-icon-grid-view': IconGridView,
  'lely-icon-grid': IconGrid,
  'lely-icon-group-add': IconGroupAdd,
  'lely-icon-group-remove': IconGroupRemove,
  'lely-icon-group': IconGroup,
  'lely-icon-health-report': IconHealthReport,
  'lely-icon-health-treatment': IconHealthTreatment,
  'lely-icon-heat': IconHeat,
  'lely-icon-help': IconHelp,
  'lely-icon-herd-movement': IconHerdMovement,
  'lely-icon-herd': IconHerd,
  'lely-icon-hide': IconHide,
  'lely-icon-history': IconHistory,
  'lely-icon-home': IconHome,
  'lely-icon-hot-rins': IconHotRins,
  'lely-icon-human': IconHuman,
  'lely-icon-income': IconIncome,
  'lely-icon-information': IconInformation,
  'lely-icon-insemination': IconInsemination,
  'lely-icon-iris-group': IconIrisGroup,
  'lely-icon-iris': IconIris,
  'lely-icon-keyboard': IconKeyboard,
  'lely-icon-language': IconLanguage,
  'lely-icon-laptop': IconLaptop,
  'lely-icon-layers-clear': IconLayersClear,
  'lely-icon-layers': IconLayers,
  'lely-icon-link': IconLink,
  'lely-icon-link-off': IconLinkOff,
  'lely-icon-list-bulletin': IconListBulletin,
  'lely-icon-list': IconList,
  'lely-icon-locate': IconLocate,
  'lely-icon-location': IconLocation,
  'lely-icon-lock': IconLock,
  'lely-icon-login': IconLogin,
  'lely-icon-logout': IconLogout,
  'lely-icon-m4use': IconM4use,
  'lely-icon-mail': IconMail,
  'lely-icon-manage': IconManage,
  'lely-icon-manure': IconManure,
  'lely-icon-map': IconMap,
  'lely-icon-map-search': IconMapSearch,
  'lely-icon-medicine': IconMedicine,
  'lely-icon-menu': IconMenu,
  'lely-icon-mfr-dosing-roller': IconMfrDosingRoller,
  'lely-icon-mfr-feed-door-closing': IconMfrFeedDoorClosing,
  'lely-icon-mfr-feed-door-opening': IconMfrFeedDoorOpening,
  'lely-icon-mfr-open': IconMfrOpen,
  'lely-icon-mfr': IconMfr,
  'lely-icon-microphone': IconMicrophone,
  'lely-icon-milk-seperation': IconMilkSeperation,
  'lely-icon-milk': IconMilk,
  'lely-icon-minus': IconMinus,
  'lely-icon-mixer-motor': IconMixerMotor,
  'lely-icon-more-horizontal': IconMoreHorizontal,
  'lely-icon-more-vertical': IconMoreVertical,
  'lely-icon-mouse': IconMouse,
  'lely-icon-network-wifi': IconNetworkWifi,
  'lely-icon-neutral': IconNeutral,
  'lely-icon-north-east': IconNorthEast,
  'lely-icon-north-west': IconNorthWest,
  'lely-icon-north': IconNorth,
  'lely-icon-notification-mute': IconNotificationMute,
  'lely-icon-notification-on': IconNotificationOn,
  'lely-icon-notification': IconNotification,
  'lely-icon-notifications': IconNotifications,
  'lely-icon-objects': IconObjects,
  'lely-icon-ongoing': IconOngoing,
  'lely-icon-opportunities': IconOpportunities,
  'lely-icon-pains': IconPains,
  'lely-icon-pan': IconPan,
  'lely-icon-panel': IconPanel,
  'lely-icon-pause': IconPause,
  'lely-icon-pdb': IconPdb,
  'lely-icon-pending': IconPending,
  'lely-icon-person-approve': IconPersonApprove,
  'lely-icon-person-assign': IconPersonAssign,
  'lely-icon-person-remove': IconPersonRemove,
  'lely-icon-person-unassign': IconPersonUnassign,
  'lely-icon-person': IconPerson,
  'lely-icon-phone': IconPhone,
  'lely-icon-picture': IconPicture,
  'lely-icon-pinc-zoom-out': IconPincZoomOut,
  'lely-icon-pinch-zoom-in': IconPinchZoomIn,
  'lely-icon-play': IconPlay,
  'lely-icon-plus': IconPlus,
  'lely-icon-power-management': IconPowerManagement,
  'lely-icon-power': IconPower,
  'lely-icon-pregnancy': IconPregnancy,
  'lely-icon-printer': IconPrinter,
  'lely-icon-qr-code-scanner': IconQrCodeScanner,
  'lely-icon-qr-code': IconQrCode,
  'lely-icon-redo': IconRedo,
  'lely-icon-refresh': IconRefresh,
  'lely-icon-reminder': IconReminder,
  'lely-icon-reports': IconReports,
  'lely-icon-reproduction-check': IconReproductionCheck,
  'lely-icon-reset': IconReset,
  'lely-icon-robot': IconRobot,
  'lely-icon-rotate-left': IconRotateLeft,
  'lely-icon-rotate-map': IconRotateMap,
  'lely-icon-rotate-right': IconRotateRight,
  'lely-icon-route-layers': IconRouteLayers,
  'lely-icon-routes': IconRoutes,
  'lely-icon-routing': IconRouting,
  'lely-icon-satisfied': IconSatisfied,
  'lely-icon-scanner': IconScanner,
  'lely-icon-scatterplot': IconScatterplot,
  'lely-icon-scale': IconScale,
  'lely-icon-screen-rotation': IconScreenRotation,
  'lely-icon-search': IconSearch,
  'lely-icon-send': IconSend,
  'lely-icon-sensor': IconSensor,
  'lely-icon-settings': IconSettings,
  'lely-icon-shopping-cart': IconShoppingCart,
  'lely-icon-show': IconShow,
  'lely-icon-signal-cellular-0-bar': IconSignalCellular0Bar,
  'lely-icon-signal-cellular-2-bar': IconSignalCellular2Bar,
  'lely-icon-signal-cellular-4-bar': IconSignalCellular4Bar,
  'lely-icon-signal-cellular-off': IconSignalCellularOff,
  'lely-icon-signal-wifi-bad': IconSignalWifiBad,
  'lely-icon-signal-wifi-off': IconSignalWifiOff,
  'lely-icon-sires': IconSires,
  'lely-icon-sort-disabled': IconSortDisabled,
  'lely-icon-sort-down': IconSortDown,
  'lely-icon-sort-up': IconSortUp,
  'lely-icon-sort': IconSort,
  'lely-icon-south-east': IconSouthEast,
  'lely-icon-south-west': IconSouthWest,
  'lely-icon-south': IconSouth,
  'lely-icon-stacked-bar-chart': IconStackedBarChart,
  'lely-icon-star-empty': IconStarEmpty,
  'lely-icon-star-filled': IconStarFilled,
  'lely-icon-stop': IconStop,
  'lely-icon-swipe-down': IconSwipeDown,
  'lely-icon-swipe-left-and-right': IconSwipeLeftAndRight,
  'lely-icon-swipe-left': IconSwipeLeft,
  'lely-icon-swipe-up': IconSwipeUp,
  'lely-icon-table-row': IconTableRow,
  'lely-icon-table': IconTable,
  'lely-icon-tablet': IconTablet,
  'lely-icon-tasks': IconTasks,
  'lely-icon-thermostat': IconThermostat,
  'lely-icon-thumb-down': IconThumbDown,
  'lely-icon-thumb-up': IconThumbUp,
  'lely-icon-touch': IconTouch,
  'lely-icon-traffic': IconTraffic,
  'lely-icon-transfer': IconTransfer,
  'lely-icon-trash': IconTrash,
  'lely-icon-tv': IconTv,
  'lely-icon-undo': IconUndo,
  'lely-icon-update': IconUpdate,
  'lely-icon-upload': IconUpload,
  'lely-icon-valve': IconValve,
  'lely-icon-version': IconVersion,
  'lely-icon-very-dissatisfied': IconVeryDissatisfied,
  'lely-icon-very-satisfied': IconVerySatisfied,
  'lely-icon-view-list': IconViewList,
  'lely-icon-warning': IconWarning,
  'lely-icon-watch': IconWatch,
  'lely-icon-water': IconWater,
  'lely-icon-west': IconWest,
  'lely-icon-wifi-off': IconWifiOff,
  'lely-icon-wifi': IconWifi,
  'lely-icon-young-stock': IconYoungStock,
  'lely-icon-zoom-in': IconZoomIn,
  'lely-icon-zoom-out': IconZoomOut,
  'lely-icon-graph-bottom': IconGraphBottom,
  'lely-icon-graph-top': IconGraphTop,
  'lely-icon-hub': IconHub,
  'lely-icon-radio-default': IconRadioDefault,
  'lely-icon-radio-checked': IconRadioChecked,
  'lely-icon-sphere': IconSphere,
  'lely-icon-amf': IconAmfRobot,
  'lely-icon-juno': IconJuno,
  'lely-icon-warning-large': IconWarningLarge,
  'lely-icon-not-found': IconNotFound,
  'lely-icon-no-robots': IconNoRobots,
  'lely-icon-expand-panel': ExpandPanel,
  'lely-icon-collapse-panel': CollapsePanel,
};

export default iconComponents;
